export default __webpack_public_path__ + "static/media/item5.5ac5fccb.svg";